import { DomainStatus, UserDomain } from '../../../types/domains.ts';
import DropDownMenu from './DropDownMenu.tsx';
import { ExternalLink } from 'lucide-react';
import { useState } from 'react';

function ActiveDomainCard({ 
  userDomain, 
  setShowInfo, 
  setShowRemove, 
  statusMessages 
}: { 
  userDomain: UserDomain, 
  setShowInfo: (open: boolean) => void, 
  setShowRemove: (open: boolean) => void, 
  statusMessages: { [key in DomainStatus]: string } 
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <>
      <div className="flex justify-between">
        <div className="flex items-center gap-2">
          <a 
            href={`https://${userDomain.domain}`} 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:underline flex items-center gap-2 text-xl font-bold text-gray-900"
          >
            {userDomain.domain} <ExternalLink className="size-5" />
          </a>
          <div className={`px-3 py-1 rounded-full text-sm bg-green-100 text-green-700 `}>
            {statusMessages[userDomain.status]}
          </div>
        </div>

        <DropDownMenu
          dropdownOpen={dropdownOpen}
          setDropdownOpen={setDropdownOpen}
          isActive={true}
          setShowInfo={setShowInfo}
          setShowRemove={setShowRemove}
        />
      </div>
    </>
  )
}

export default ActiveDomainCard;